import { Row } from 'src/shared/components/Semantic/all'

export const RequestChatDateDivider = ({ label }: { label: string }) => (
  <Row className="items-center justify-center py-3">
    <span className="rounded-full bg-muted/70 px-3 py-1 text-xs font-medium text-muted-foreground">
      {label}
    </span>
  </Row>
)
